import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Constants } from '../../constants';
import { Observable } from 'rxjs/internal/Observable';
import { isExternalApi } from './interceptor-utils';

@Injectable()
export class HttpDomainInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip external API calls (Aeris, etc.)
        if (isExternalApi(req.url)) {
            return next.handle(req);
        }
        
        // Add base domain for relative URLs
        if (!req.url.startsWith('http')) {
            req = req.clone({url: Constants.BASE_DOMAIN + req.url});
        }
        return next.handle(req);
    }
}
